export const GitBranch = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fill="#706F78"
        d="M12.5 3.958a2.708 2.708 0 1 1 5.417 0 2.708 2.708 0 0 1-5.417 0ZM2.083 16.042a2.708 2.708 0 1 1 5.417 0 2.708 2.708 0 0 1-5.417 0Zm0-12.084a2.708 2.708 0 1 1 5.417 0 2.708 2.708 0 0 1-5.417 0Zm2.709 1.459a1.459 1.459 0 1 0-.001-2.918 1.459 1.459 0 0 0 0 2.918Zm0 12.083a1.459 1.459 0 1 0-.001-2.918 1.459 1.459 0 0 0 0 2.918ZM15.208 5.417a1.459 1.459 0 1 0 0-2.918 1.459 1.459 0 0 0 0 2.918Z"
      />
      <path
        fill="#706F78"
        d="M4.792 13.958a.625.625 0 0 1-.625-.625V6.667a.625.625 0 1 1 1.25 0v6.666a.625.625 0 0 1-.625.625Z"
      />
      <path
        fill="#706F78"
        d="M14.583 7.292v-.834h1.25v.834a3.125 3.125 0 0 1-3.125 3.125H6.875a1.458 1.458 0 0 0-1.458 1.458h-1.25a2.708 2.708 0 0 1 2.708-2.708h5.833a1.875 1.875 0 0 0 1.875-1.875Z"
      />
    </svg>
  )
}
